import { SSN_MAX_LENGTH } from 'shared/utils/string/ssn';
import { z } from 'zod';

export const ssnValidationMessages = {
  invalidLength: '9 digits required',
  required: 'Required',
};

export const ssnSchema = z
  .string({ error: ssnValidationMessages.required })
  .min(1, { error: ssnValidationMessages.required })
  .length(SSN_MAX_LENGTH, { error: ssnValidationMessages.invalidLength });
